import { useState } from 'react';
import API from '../api';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const inp = (extra={}) => ({ width:'100%',padding:'10px 13px',border:'1.5px solid #E5E7EB',borderRadius:9,fontSize:'0.9rem',outline:'none',background:'#FAFAFA',boxSizing:'border-box',fontFamily:"'Golos Text',sans-serif",...extra });
const lbl = { display:'block',fontSize:'0.75rem',fontWeight:700,color:'#6B7280',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.05em' };

export default function AdminSettings() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ currentPassword:'',newPassword:'',confirm:'' });
  const [msg, setMsg]   = useState(null);
  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const changePass = async () => {
    if (!form.currentPassword||!form.newPassword) { setMsg({ text:'Заполните все поля',type:'error' }); return; }
    if (form.newPassword!==form.confirm) { setMsg({ text:'Пароли не совпадают',type:'error' }); return; }
    if (form.newPassword.length<6) { setMsg({ text:'Минимум 6 символов',type:'error' }); return; }
    try {
      await API.post('/auth/change-password',{ currentPassword:form.currentPassword,newPassword:form.newPassword });
      setMsg({ text:'✓ Пароль изменён',type:'success' });
      setForm({ currentPassword:'',newPassword:'',confirm:'' });
    } catch { setMsg({ text:'Неверный текущий пароль',type:'error' }); }
  };

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'1.4rem',color:'#06101e',margin:'0 0 4px' }}>Настройки</h1>
        <p style={{ color:'#9CA3AF',fontSize:'0.875rem',margin:0 }}>Безопасность аккаунта</p>
      </div>

      <div style={{ display:'grid',gap:16,maxWidth:540 }}>
        {/* Change password */}
        <div style={{ background:'#fff',borderRadius:16,padding:'24px',boxShadow:'0 1px 8px rgba(0,0,0,.06)',border:'1px solid #F0F0F0' }}>
          <h2 style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:700,fontSize:'1rem',color:'#06101e',margin:'0 0 18px',display:'flex',alignItems:'center',gap:8 }}>
            🔐 Смена пароля
          </h2>
          <div style={{ display:'grid',gap:14,marginBottom:18 }}>
            {[['currentPassword','Текущий пароль'],['newPassword','Новый пароль'],['confirm','Повторите новый пароль']].map(([k,label])=>(
              <div key={k}>
                <label style={lbl}>{label}</label>
                <input type="password" value={form[k]} onChange={e=>set(k,e.target.value)} style={inp()} onFocus={e=>e.target.style.borderColor='#00C2B8'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
              </div>
            ))}
          </div>
          {msg && (
            <div style={{ padding:'10px 14px',borderRadius:10,fontSize:'0.85rem',fontWeight:600,marginBottom:14,background:msg.type==='success'?'#F0FDF4':'#FEF2F2',color:msg.type==='success'?'#166534':'#DC2626',border:`1px solid ${msg.type==='success'?'#BBF7D0':'#FCA5A5'}` }}>
              {msg.text}
            </div>
          )}
          <button onClick={changePass} style={{ padding:'11px 24px',background:'#00C2B8',color:'#06101e',border:'none',borderRadius:10,fontFamily:"'Unbounded',sans-serif",fontWeight:700,fontSize:'0.82rem',cursor:'pointer' }}>Изменить пароль</button>
        </div>

        {/* Logout */}
        <div style={{ background:'#fff',borderRadius:16,padding:'20px 24px',boxShadow:'0 1px 8px rgba(0,0,0,.06)',border:'1px solid #F0F0F0',display:'flex',alignItems:'center',justifyContent:'space-between' }}>
          <div>
            <div style={{ fontWeight:700,fontSize:'0.9rem',color:'#111',marginBottom:3 }}>Выход из системы</div>
            <div style={{ fontSize:'0.8rem',color:'#9CA3AF' }}>Завершить текущую сессию</div>
          </div>
          <button onClick={()=>{ logout(); nav('/admin/login'); }} style={{ padding:'9px 18px',background:'#FEF2F2',color:'#EF4444',border:'1px solid #FECACA',borderRadius:9,fontWeight:700,fontSize:'0.82rem',cursor:'pointer' }}>Выйти</button>
        </div>

        {/* Site link */}
        <div style={{ background:'#F5F7FA',borderRadius:14,padding:'16px 20px',border:'1px solid #F0F0F0',display:'flex',alignItems:'center',justifyContent:'space-between' }}>
          <div style={{ fontSize:'0.875rem',color:'#6B7280' }}>Перейти на сайт</div>
          <a href="/" target="_blank" style={{ color:'#00C2B8',fontWeight:700,fontSize:'0.85rem',textDecoration:'none' }}>mastercleanpro.uz →</a>
        </div>
      </div>
    </div>
  );
}
